export const FORM_ID = 'form-ai-quick-filters-id'

export const SEARCH_AI_INPUT_ID = 'search-ai-quick-filters-input-id'
export const INPUT_MAX_LENGTH = 140

export const BASE_CLASS = 'mt-SearchAiQuickFilters'
